module.exports = __webpack_public_path__ + "img/flag_logo1.cdd8e3bf.png";